import * as React from 'react';
import {
  Box,
  Button,
  Dialog, DialogContent, DialogTitle,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';

import { ReactComponent as SoakSvg } from '../../assets/icons/soaking.svg';
import { ReactComponent as BroncaSvg } from '../../assets/icons/bronca.svg';
import { ReactComponent as WorkCompleteSvg } from '../../assets/icons/workComplete.svg';

interface ScanOutDialogProps {
  barcode: string;
  onClose: () => void;
  showModal: boolean;
  isJeweler: boolean;
  startSoaking?: () => void;
  showRejectReasonDialog: React.Dispatch<React.SetStateAction<boolean>>;
  workComplete: () => void;
}

const useStyles = makeStyles(() => ({
  buttonIcon: {
    padding: '4px 4px',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

const ScanOutDialog: React.FC<ScanOutDialogProps> = ({
  barcode, onClose, showModal, startSoaking, showRejectReasonDialog, workComplete, isJeweler,
}) => {
  const classes = useStyles();

  const handleClose = (event: React.SyntheticEvent, reason: string) => {
    if (reason === 'escapeKeyDown' || reason === 'backdropClick' || reason === 'disableEnforceFocus') {
      // do nothing
    } else {
      onClose();
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      open={showModal}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        <Typography variant="subtitle2">
          {'Repair Item: '}
          {barcode}
        </Typography>
        <Typography variant="h5" id="dialog-header">{'Select reason why item was removed from Scanner.'}</Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3} style={{ paddingTop: '15px' }}>
          {
            isJeweler
            && (
            <Grid item xs={12}>
              <Box className={classes.iconContainer}>
                <Button className={classes.buttonIcon} onClick={() => startSoaking?.()}>
                  <SoakSvg width={300} height={240} />
                </Button>
              </Box>
            </Grid>
            )
          }
          <Grid item xs={6}>
            <Box className={classes.iconContainer}>
              <Button className={classes.buttonIcon} onClick={() => workComplete()}>
                <WorkCompleteSvg width={300} height={240} />
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className={classes.iconContainer}>
              <Button className={classes.buttonIcon} onClick={() => showRejectReasonDialog(true)}>
                <BroncaSvg width={300} height={240} />
              </Button>
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Box pb={3} />
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ScanOutDialog;
